module.exports = __webpack_public_path__ + "img/file-icon_jpeg.4bf0512f.svg";